import type { IconProps } from './icons.types';

export function TuneIcon({ size = 18 }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 18 18" fill="currentColor" aria-hidden="true">
      <path d="M5.5 7.5L4 7.5L4 4.5L-5.68248e-07 4.5L-6.33815e-07 3L4 3L4 -1.74846e-07L5.5 -2.40413e-07L5.5 7.5ZM17.5 4.5L8 4.5L8 3L17.5 3L17.5 4.5ZM17.5 14.5L13.5 14.5L13.5 17.5L12 17.5L12 10L13.5 10L13.5 13L17.5 13L17.5 14.5ZM9.5 14.5L-1.31134e-07 14.5L-1.96701e-07 13L9.5 13L9.5 14.5Z" />
    </svg>
  );
}
